import { bloomScale } from "../../lib/questions";
import { QuestionStepShell } from "./QuestionStepShell";
import type { QuestionStepProps } from "./types";

/** Visueel continuum: zachte kleurgradient met stappen. */
export function QuestionStepSpectrum({
  question,
  questionIndex,
  totalQuestions,
  selectedValue,
  onSelect,
  onBack,
  canGoBack,
}: QuestionStepProps) {
  return (
    <QuestionStepShell
      question={question}
      questionIndex={questionIndex}
      totalQuestions={totalQuestions}
      selectedValue={selectedValue}
      onSelect={onSelect}
      onBack={onBack}
      canGoBack={canGoBack}
    >
      <div className="bloom-spectrum" role="group" aria-label="Antwoordopties">
        <div className="bloom-spectrum__bar" aria-hidden="true" />
        <div className="bloom-spectrum__stops">
          {bloomScale.labels.map((label, index) => (
            <button
              key={index}
              type="button"
              className={`bloom-spectrum__stop${selectedValue === index ? " bloom-spectrum__stop--selected" : ""}`}
              aria-pressed={selectedValue === index}
              aria-label={label}
              onClick={() => onSelect(index)}
            >
              <span className="bloom-spectrum__dot" />
              <span className="bloom-spectrum__stop-label">{label}</span>
            </button>
          ))}
        </div>
      </div>
    </QuestionStepShell>
  );
}
